const base = '/profile'

const routes = {
  root: base,
  progress: `${base}/progress`,
  card: `${base}/personal-card`,
  account: `${base}/account`,
}

export default routes
